document.addEventListener('DOMContentLoaded', function () {
  var variants = null;
  var handle = location.pathname.split('/products/')[1]?.split('?')[0];

  // 页面加载时拉一份权威的"尺寸+画框 → 变体ID"对照表，作为校验标准
  // 用 Shopify 公开的 /products/{handle}.js 接口，不需要额外权限
  if (handle) {
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (data) { variants = data.variants; })
      .catch(function () { /* 拉取失败时不做任何拦截，避免影响正常购买 */ });
  }

  function getCurrentSizeText() {
    var el = document.querySelector('.dropdown-button-gsw__value');
    var t = el ? el.textContent.trim() : null;
    return t && t !== 'Select a Size' ? t : null;
  }

  function getCurrentFrameValue() {
    var checked = document.querySelector('input[name="globo-option-1"]:checked');
    var li = checked ? checked.closest('li') : null;
    return li ? li.getAttribute('data-value') : null;
  }

  // 根据当前视觉上选中的 Size + Frame，独立算出"应该是哪个变体"，
  // 不依赖页面自己那个可能还没追上的隐藏 id 输入框
  function computeCorrectVariantId() {
    if (!variants) return null;
    var size = getCurrentSizeText();
    var frame = getCurrentFrameValue();
    if (!size || !frame) return null;
    var match = variants.find(function (v) {
      return v.option1 === size && v.option2 === frame;
    });
    return match ? match.id : null;
  }

  function setButtonsDisabled(disabled) {
    document.querySelectorAll('buy-buttons button, product-sticky-bar button').forEach(function (btn) {
      btn.disabled = disabled;
      btn.style.opacity = disabled ? '0.5' : '';
      btn.style.pointerEvents = disabled ? 'none' : '';
    });
  }

  function isSynced() {
    var idInput = document.querySelector('input[name="id"]');
    var correct = computeCorrectVariantId();
    // correct 为 null 时（比如该组合本身不存在/售罄），不算作"未同步"，避免按钮被永久锁死
    return correct == null || (idInput && idInput.value === String(correct));
  }

  var pollTimer = null;

  function startGuarding() {
    setButtonsDisabled(true);
    if (pollTimer) clearInterval(pollTimer);
    var attempts = 0;
    pollTimer = setInterval(function () {
      attempts++;
      if (isSynced()) {
        setButtonsDisabled(false);
        clearInterval(pollTimer);
      } else if (attempts > 100) {
        // 兜底：最多等 10 秒，避免极端情况下（如接口拉取失败）按钮被永久锁死
        setButtonsDisabled(false);
        clearInterval(pollTimer);
      }
    }, 100);
  }

  // 任意选项改动时，重新开始"禁用直到同步"这个流程
  document.addEventListener(
    'change',
    function (e) {
      var input = e.target;
      if (input && input.matches && input.matches('input[type="radio"][name^="globo-option-"]')) {
        startGuarding();
      }
    },
    true
  );

  // 兜底拦截：正常情况下按钮已被禁用不会走到这一步；
  // 万一有遗漏场景导致按钮仍可点击但尚未同步，这里再拦一次，防止提交错误变体
  document.addEventListener(
    'click',
    function (e) {
      if (e.target.closest('buy-buttons button, product-sticky-bar button')) {
        if (!isSynced()) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      }
    },
    true
  );
});